import { Component, OnInit } from '@angular/core';
import { MouseEntityService } from '../mouse/mouse-entity.service';

@Component({
  selector: 'ng3-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.css'],
  providers: [MouseEntityService],
})
export class ControlsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
